<template>
  <div class="dup__media__call__btn">
    <b-button
      @click="duplicateMediaCall"
      v-b-tooltip.hover
      title="Duplicate"
      class="duplicate-media-call-btn"
      variant="theme"
    >
      <i class="fas fa-copy"></i>
    </b-button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ['deliverableId', 'namespace', 'deliverableTemplateId'],
    computed: {
  	...mapState({
    state (state) {
      return state[this.namespace]
    },
    getDeliverableTemplateSlug (state, getters) {
      return getters['getDeliverableTemplateSlug']
    },
  	}),
  },
  methods: {

    duplicateMediaCall() {
      let that = this;
      let slug = "";

      if (this.deliverableTemplateId) {
     	 slug = this.getDeliverableTemplateSlug(this.deliverableTemplateId);
     	}

      if (slug == "social-media") {
	      let that = this;
	      this.$store.dispatch(this.namespace + 'duplicateSocialMedia', {deliverableId: this.deliverableId}).then(function() {
	      	// TODO: determine if we need to call fetch social media deliverables grouped.
	        that.$store.dispatch(that.namespace + 'fetchSocialMediaDeliverablesGrouped').then(function() {
	        	that.$store.dispatch(that.namespace + 'fetchProjectDeliverable').then(function() {
	          	that.$store.dispatch(that.namespace + 'manageUndoActivation', 'Deliverable duplicated.');
	          });
	        });
          if (that.namespace == "") {
	        that.$bvModal.hide("editSocialModal");
          } else {
            that.$bvModal.hide("editRelatedSocialModal");
          }
	        // TODO: re-open social media modal after duplicating?
	        window.scrollTo(0, 0);
	      });
      } else {
      	if (slug == "organic-social-media-plan") {
      		that.$root.$emit('openDuplicateDeliverableModal', {deliverableId:this.deliverableId});
      	} else {
		      	this.$store.dispatch(this.namespace + 'duplicateMediaCall', {deliverableId: this.deliverableId}).then(function() {
		      	  that.$store.dispatch(that.namespace + 'fetchDeliverables').then(function() {
		      	  	that.$store.dispatch(that.namespace + 'fetchProjectDeliverable').then(function() {
		      	    	that.$store.dispatch(that.namespace + 'manageUndoActivation', 'Deliverable duplicated.');
		      	    });
		      	  });
		          if (slug == "organic-social-media-plan") {
		            that.$bvModal.hide("editOrganicSocialMediaPlanModal");
		          } else {
		            that.$bvModal.hide("editDeliverableModal");
		          }
		      	  window.scrollTo(0, 0);
		      	});
	      }
      }

    },
  },
};
</script>

<style>
</style>